import React, { useState } from "react";
import VideoPlayerWithThumbnail from "../../../components/VideoPlayerWithThumbnail";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/other/NoRecord";
import { setSeletectedPresentation } from "../../../redux/reducers/getStartReducer";

const Presentation = () => {
  const [isViewAll, setIsViewAll] = useState(false);
  const dispatch = useDispatch();
  const { leaguePresentationData, selectedPresentation } = useSelector(
    (state) => state?.getStartReducer
  );

  return (
    <section class="ct_leagu_presentation_bg">
      <div class="container">
        <div class="row">
          <div
            class={`col-lg-${
              leaguePresentationData?.length > 0 ? "4" : "12"
            } mb-4 mb-lg-0`}
          >
            <h1 class="ct_fs_28 text-white">Leagues presentations</h1>
            <div class="ct_leage_presentation_list_main mt-5">
              {leaguePresentationData?.length > 0 ? (
                leaguePresentationData
                  ?.slice(0, isViewAll ? leaguePresentationData.length : 5)
                  ?.map((item, index) => (
                    <div
                      class={`${
                        index > 0 ? "mt-2" : ""
                      } ct_leage_presentation_list ${
                        selectedPresentation?.id == item?.id ? "active" : ""
                      }`}
                      onClick={() => dispatch(setSeletectedPresentation(item))}
                    >
                      <div class="ct_presentation_icon">
                        <i class="fa-solid fa-play"></i>
                      </div>
                      <div>
                        <h4 class="mb-0 ct_fs_24 text-white">
                          {item?.presentation_title ?? ""}
                        </h4>
                      </div>
                    </div>
                  ))
              ) : (
                <NoRecord className={"text-white"} />
              )}
            </div>
            {leaguePresentationData?.length > 5 && !isViewAll && (
              <div class="w-100 mt-4">
                <a
                  href="javascript:void(0)"
                  class="btn btn-secondary me-2 ct_btn_animate w-100"
                  onClick={() => setIsViewAll(true)}
                >
                  View All Videos
                </a>
              </div>
            )}
          </div>
          {leaguePresentationData?.length > 0 && selectedPresentation && (
            <div class="col-lg-8 mb-4 mb-lg-0">
              <h1 class="ct_fs_28 text-white">RC101 presentations</h1>

              <div class="ct_presentantion_video mt-5">
                <VideoPlayerWithThumbnail
                  videoUrl={selectedPresentation?.presentation_youtube_link}
                  thumbnailUrl={selectedPresentation?.presentation_cover_image}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Presentation;
